import React, { useState } from "react";
import MobileFooter from "../Core/Footer/MobileFooter";
import LocationPopup from "../Core/LocationPopup";
import DesktopFooter from "../Core/Footer/DesktopFooter";
import BFCMFooter from "../BFCMFooter/Footer"; 
import { useLocation } from "@reach/router";

const Footer = ({ t, alternatePath, overlay }) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const location = useLocation();


  const isBFCMPage = location.pathname.includes("/bfcm");

  const handlePopup = (value) => {
    setPopupOpen(value);
  };

  return (
    <>
      <footer>
        {isBFCMPage ? (
          <BFCMFooter t={t} handlePopup={handlePopup} /> 
        ) : (
          <>
            <MobileFooter handlePopup={handlePopup} overlay={overlay} />
            <DesktopFooter t={t} handlePopup={handlePopup} />
          </>
        )}
      </footer>
      <LocationPopup
        handlePopup={handlePopup}
        isOpen={popupOpen}
        alternatePath={alternatePath}
      />
    </>
  );
};

export default Footer;
